'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var Link = require('../../00.helper/Link/Link.js');
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../Icon/Icon.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-link-button',
    cnIcon = "".concat(CLASSNAME, "__icon"),
    cnBold = "".concat(CLASSNAME, "--bold"),
    cnUnderline = "".concat(CLASSNAME, "--underline");
/**
 * 
 * @param {*} props 
 * @returns 
 */

function ButtonLink(_ref) {
  var _classNames2;

  var bold = _ref.bold,
      className = _ref.className,
      dataFunction = _ref.dataFunction,
      dataType = _ref.dataType,
      iconId = _ref.iconId,
      iconLeft = _ref.iconLeft,
      iconSize = _ref.iconSize,
      link = _ref.link,
      onClick = _ref.onClick,
      rel = _ref.rel,
      style = _ref.style,
      tagName = _ref.tagName,
      target = _ref.target,
      title = _ref.title,
      type = _ref.type,
      underline = _ref.underline;

  if (!tagName) {
    var _classNames;

    return /*#__PURE__*/React__default.createElement(Link, {
      onClick: onClick,
      link: link,
      className: classNames(className, CLASSNAME, (_classNames = {}, _rollupPluginBabelHelpers.defineProperty(_classNames, "".concat(CLASSNAME, "--").concat(type), type), _rollupPluginBabelHelpers.defineProperty(_classNames, "".concat(CLASSNAME, "--").concat(style), style), _rollupPluginBabelHelpers.defineProperty(_classNames, cnBold, bold), _rollupPluginBabelHelpers.defineProperty(_classNames, cnUnderline, underline), _classNames)),
      target: target,
      rel: rel,
      "data-type": dataType,
      "data-function": dataFunction
    }, iconLeft && /*#__PURE__*/React__default.createElement(Icon, {
      id: iconLeft,
      size: iconSize,
      className: cnIcon
    }), title && /*#__PURE__*/React__default.createElement("span", null, title), iconId && /*#__PURE__*/React__default.createElement(Icon, {
      id: iconId,
      size: iconSize,
      className: cnIcon
    }));
  }

  var Tag = tagName;
  return /*#__PURE__*/React__default.createElement(Tag, {
    className: classNames(className, CLASSNAME, (_classNames2 = {}, _rollupPluginBabelHelpers.defineProperty(_classNames2, "".concat(CLASSNAME, "--").concat(type), type), _rollupPluginBabelHelpers.defineProperty(_classNames2, "".concat(CLASSNAME, "--").concat(style), style), _rollupPluginBabelHelpers.defineProperty(_classNames2, cnBold, bold), _rollupPluginBabelHelpers.defineProperty(_classNames2, cnUnderline, underline), _classNames2)),
    href: link,
    target: target,
    rel: rel,
    onClick: onClick ? function (e) {
      e.preventDefault();
      onClick(e);
    } : null,
    "data-yype": dataType,
    "data-function": dataFunction
  }, iconLeft && /*#__PURE__*/React__default.createElement(Icon, {
    id: iconLeft,
    size: iconSize,
    className: cnIcon
  }), title && /*#__PURE__*/React__default.createElement("span", null, title), iconId && /*#__PURE__*/React__default.createElement(Icon, {
    id: iconId,
    size: iconSize,
    className: cnIcon
  }));
}
ButtonLink.propTypes = {
  /** True if bold */
  bold: PropTypes.bool,

  /** Additional class name */
  className: PropTypes.string,

  /** */
  dataFunction: PropTypes.string,

  /** */
  dataType: PropTypes.string,

  /** Id of icon on the right */
  iconId: PropTypes.string,

  /** Id of icon on the left */
  iconLeft: PropTypes.string,

  /** Size of icon */
  iconSize: PropTypes.string,

  /** */
  link: PropTypes.string,

  /** Callback */
  onClick: PropTypes.func,

  /** */
  rel: PropTypes.string,

  /** */
  style: PropTypes.oneOf(['light', 'dark']),

  /** */
  tagName: PropTypes.string,

  /** */
  target: PropTypes.string,

  /** */
  title: PropTypes.string,

  /** */
  type: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),

  /** */
  underline: PropTypes.bool
};
ButtonLink.defaultProps = {
  iconSize: 'xs',
  link: '/',
  type: 'primary'
};

module.exports = ButtonLink;
